export default "//cloud.imgsmail.ru/cloud.mail.ru/178578/img/build/empty-state/select_from_cloud.png";